const PROFILEVIEW = {
  cropImage: "Crop image",
  changePassword: "Change password",
  address: "Address",
  textValidationAddress: "Verify that the structure of the address is an example: Calle 84 24 - 78, Bogotá",
  profileUser: "User profile",
  name: "Name",
  enterName: "Enter the name",
  lastname: "Last name",
  enterLastname: "Enter last name",
  company: "Company",
  enterCompany: "Enter company name",
  department: "Department",
  city: "City",
  rol: "Role",
  enterRol: "Enter role name",
  local: "Local",
  update: "To update",
  matchPassword: "The passwords do not match.",
  user: "User",
  EmptyFields: "Missing fields to complete",
  updateUser: "Updated user successfully."
};

export default { PROFILEVIEW };
